import React from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';

class AlertFrequency extends React.Component {

    constructor(props) {
        super(props);

        this.changeFrequency = this.changeFrequency.bind(this);
    }

    changeFrequency(event) {
        let inputValue = event.target.value;
        this.props.saveData({'frequency': inputValue});
    }

    render() {

        return (
            <div className='create-alert-page__step-two--frequency'>
                <div className='frequency-title'>
                    <FormattedMessage id='Alerts_Create_UIText_steps.step2.chooseFrequency'/>
                </div>

                <select id="create-alert-frequency"
                        value={this.props.data.frequency}
                        onChange={this.changeFrequency}>
                    {/*<option value="REAL_TIME">*/}
                        {/*{this.props.intl.formatMessage({id: 'Alerts_Create_UIText_steps.step2.realTime'})}*/}
                    {/*</option>*/}
                    <option value="HOURLY">
                        {this.props.intl.formatMessage({id: 'Alerts_Create_UIText_steps.step2.hourly'})}
                    </option>
                    <option value="DAILY">
                        {this.props.intl.formatMessage({id: 'Alerts_Create_UIText_steps.step2.daily'})}
                    </option>
                    {/*<option value="WEEKLY">*/}
                        {/*{this.props.intl.formatMessage({id: 'Alerts_Create_UIText_steps.step2.weekly'})}*/}
                    {/*</option>*/}
                    {/*<option value="MONTHLY">*/}
                        {/*{this.props.intl.formatMessage({id: 'Alerts_Create_UIText_steps.step2.monthly'})}*/}
                    {/*</option>*/}
                </select>
            </div>
        )
    }

}

export default injectIntl(AlertFrequency);


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/StepTwoComponents/CreateAlert.StepTwo.AlertFrequency.jsx